import { useQueryParams, SlugIdParam } from '@/hooks/useQueryParams';

interface ILecturePageQueryParams {
  id: string;
}

export const useLecturePageQueryParams = () =>
  useQueryParams<ILecturePageQueryParams>({
    id: SlugIdParam,
  });
